import $ from 'jquery'

const hideOrShowCheckoutFields = () => {
  $(document).ready(function () {
    let billingCompany = null
    let shippingCompany = null
    let vat = null
    hideShowFields() // this calls it on load

    $('input[name=billing_customer_type]').click(hideShowFields)

    function hideShowFields () {
      if ($('input[name=billing_customer_type]:checked').val() === 'privato') {
        // Detach
        billingCompany = $('#billing_company_field').detach()
        shippingCompany = $('#shipping_company_field').detach()
        vat = $('#vat_number_field').detach()
      } else {
        // Append
        if (billingCompany) {
          billingCompany.insertAfter('#billing_last_name_field')
          billingCompany = null
        }
        if (shippingCompany) {
          shippingCompany.insertAfter('#shipping_last_name_field')
          shippingCompany = null
        }
        if (vat) {
          vat.insertAfter('#billing_company_field')
          vat = null
        }
      }
    }
  })
}

export default hideOrShowCheckoutFields
